import { jsxs, jsx } from "react/jsx-runtime";
import { Component } from "react";
import PropTypes from "prop-types";
import ChatIcon from "./ChatIcon.js";
class EndingView extends Component {
  render() {
    return /* @__PURE__ */ jsxs("div", { id: "chat-view", className: "ending-view", children: [
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(ChatIcon, { className: "large" }),
        /* @__PURE__ */ jsx("span", { className: "are-you-sure", children: "Are you sure you want to end this chat?" }),
        /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("button", { onClick: this.props.onEndChatClick, className: "end-chat", children: "Yes, end the chat" }) })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "return-to-chat", children: /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
        "button",
        {
          className: "flat-white",
          onClick: this.props.onReturnToChatClick,
          children: "Return to chat"
        }
      ) }) })
    ] });
  }
}
EndingView.propTypes = {
  onEndChatClick: PropTypes.func,
  onReturnToChatClick: PropTypes.func
};
export {
  EndingView as default
};
//# sourceMappingURL=EndingView.js.map
